import { Grid } from '@farewill/ui'

import InputFloating from 'components/form/input-floating'
import { VEHICLE_SCHEMA } from 'lib/probate/estate-questionnaire-schema'

import { VEHICLE_CONDITION_OPTIONS, VEHICLE_TYPE_OPTIONS } from '../options'
import { RecordCollection, RecordsList } from './records-section'

type Props = {
  collection: RecordCollection
}

// vehicles are vehicle_or_possession items: make and model is the
// description and the registration is the reference number
const Vehicles = ({ collection }: Props) => (
  <RecordsList
    cardType="Vehicle"
    addLabel="Add vehicle"
    collection={collection}
    schema={VEHICLE_SCHEMA}
    // short fields, so they stay two by two even in a half-width card
    renderFields={({ handleSave }) => (
      <>
        <Grid.Item span={6}>
          <InputFloating
            name="vehicleType"
            label="Vehicle type"
            component="select"
            options={VEHICLE_TYPE_OPTIONS}
            handleSave={handleSave}
          />
        </Grid.Item>
        <Grid.Item span={6}>
          <InputFloating
            name="referenceNumber"
            label="Registration number"
            handleSave={handleSave}
          />
        </Grid.Item>
        <Grid.Item span={6}>
          <InputFloating
            name="description"
            label="Make and model"
            handleSave={handleSave}
          />
        </Grid.Item>
        <Grid.Item span={6}>
          <InputFloating
            name="vehicleCondition"
            label="Condition"
            component="select"
            options={VEHICLE_CONDITION_OPTIONS}
            handleSave={handleSave}
          />
        </Grid.Item>
        <Grid.Item span={12}>
          <InputFloating
            name="value"
            label="Estimated value (£)"
            isCurrency
            handleSave={handleSave}
          />
        </Grid.Item>
      </>
    )}
  />
)

export default Vehicles
